export const defaultPlaceholder = '-';

export const ifNullOrEmpty = (
	value: string | undefined | null,
	defaultValue = defaultPlaceholder
): string => {
	if (typeof value !== 'string' || value.trim() === '') {
		return defaultValue;
	}
	return value ?? defaultValue;
};

export const escapeHtml = (s: string) =>
	s.replace(
		/[&<>"']/g,
		(m) =>
			({
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#39;',
			})[m] || m
	);
